
import { CorrectionManagerModel, TenantUserModel } from '@/libs/Api';
import { Guid } from '@/libs/common/functions/guid';
import Page from '@/Page.vue';
import { Component, Prop, Ref, VModel, Watch } from 'vue-property-decorator';
import { tenantUsersStore } from '@/libs/tenants/+state/store';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';

@Component({})
export default class CorrectionManagerList extends Page {
    @Prop() tenantId!: string;
    @Prop() categoryId!: string;

    @VModel() correctionManagers!: CorrectionManagerModel[];

    get exitingCorrectionManagers(): Array<string> {
        return this.correctionManagers.select((x) => x.tenantUserId!).toArray();
    }

    private addClick() {
        const items = [...this.correctionManagers];
        items.push({
            id: Guid.EmptyGuid(),
            tenantUserId: Guid.EmptyGuid(),
            categoryId: this.categoryId,
        } as CorrectionManagerModel);
        this.$emit('input', items);
    }

    mounted() {
        if (this.correctionManagers.length == 0) {
            this.addClick();
        }
    }

    private deleteItem(index: number) {
        this.correctionManagers.splice(index, 1);
    }

    /**
     * Kontroluje, zda daný uživatel (dle tenantUserId) má přístup k této kategorii
     */
    private checkUserCategoryAccess(tenantUserId: string | null | undefined): boolean {
        if (!tenantUserId) {
            return true;
        }
        const allTenantUsers = (tenantUsersStore.useGetter(CrudGetter.Data) as TenantUserModel[]) ?? [];
        const user = allTenantUsers.find((u) => u.id == tenantUserId);
        if (!user) {
            return true;
        }
        if (user.accessAllCategories) {
            return true;
        }
        return user.categories?.some((c: any) => c.categoryId == this.categoryId) == true;
    }
}
